import * as _ from 'lodash';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';

import { BREAKPOINTS } from '../../../constants/breakpoints';
import { contentCardMap } from '../../ContentCards/Mappings';

const sortByTagsAndFranchises = (match, items) => {
  return items
    .map((item) => {
      const franchiseMatch =
        item.franchise?.franchiseName === match.franchise?.franchiseName
          ? +1
          : +0;
      return {
        ...item,
        weight:
          _.intersectionBy(item.tags, match.tags, 'name').length +
          franchiseMatch,
      };
    })
    .sort((x, y) => y.weight - x.weight)
    .slice(0, 3);
};

const renderContentCard = (data, viewport) => {
  return (
    <div className={`${viewport === 'tablet' ? 'long' : 'standard'}`}>
      {React.createElement(contentCardMap[data.internal.type], {
        data,
        topic: true,
        type: viewport === 'tablet' ? 'long' : 'standard',
      })}
    </div>
  );
};

const ArticleRecirculation = ({
  articleFranchises,
  articleTags,
  articleTitle,
  data: { allContentfulFranchises, allContentfulTag },
}) => {
  const [viewport, setViewport] = useState(undefined);

  const handleResize = () => {
    if (window.innerWidth <= BREAKPOINTS.mobileXL) {
      setViewport('mobile');
    } else if (window.innerWidth <= BREAKPOINTS.tabletXL) {
      setViewport('tablet');
    } else {
      setViewport('desktop');
    }
  };

  const tags = allContentfulTag.nodes || [];
  const franchise = allContentfulFranchises.nodes || [];

  const combinedContent = [...tags, ...franchise];

  // get all actual nodes
  const allArticles = combinedContent
    .filter((content) => content.article___long_form !== null)
    .map((content) => content.article___long_form)
    .reduce((a, b) => [...a, ...b]);

  const allStories = combinedContent
    .map((content) => content.story || [])
    .reduce((a, b) => [...a, ...b]);

  // should be id instead
  const articleCards = allArticles
    .filter((content) => content.header.title !== articleTitle)
    .map((content) => {
      const cardWithTags = {
        franchise: content.franchise,
        tags: content.tags,
        ...content,
      };
      return cardWithTags;
    });

  const uniqueArticleCards = _.uniqBy(articleCards, 'id');

  const storyCards = allStories.filter((content) => content !== null);

  const uniqueStoryCards = _.uniqBy(storyCards, 'articleTitle');

  const contentCards = [...uniqueArticleCards, ...uniqueStoryCards];

  const sortedContentCards = sortByTagsAndFranchises(
    {
      franchise: articleFranchises,
      tags: articleTags,
    },
    contentCards,
  );

  useEffect(() => {
    const handler = () => handleResize(window);
    window.addEventListener('resize', handler);
    handleResize();
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div className="article__recirculation">
      <div className="header">
        <h6>You might like these, too</h6>
      </div>
      {sortedContentCards &&
        sortedContentCards.map((content) =>
          renderContentCard(content, viewport),
        )}
    </div>
  );
};

ArticleRecirculation.propTypes = {
  articleFranchises: PropTypes.object,
  articleTags: PropTypes.array,
  articleTitle: PropTypes.string,
  data: PropTypes.object,
};

export default ArticleRecirculation;
